import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LockOutlined, UserOutlined } from '@/ui/compat/icons';
import { Button } from '@/ui/compat/antd';
import useAmicale from '../hooks/useAmicale';

const AmicaleLoginForm = ({ onSubmit, loading, error }) => {
  const { t } = useTranslation();
  const { client } = useAmicale();
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!login || !password) return;
    await onSubmit({ login, password });
  };

  return (
    <div className='min-h-[60vh] flex items-center justify-center px-4 py-12'>
      <form
        onSubmit={handleSubmit}
        className='w-full max-w-md bg-white rounded-2xl shadow-xl border border-gray-100 p-8'
      >
        <div className='text-center mb-6'>
          <h2 className='text-xl font-bold text-gray-900 mb-1'>
            {t('amicales.login.title')}
          </h2>
          <p className='text-sm text-gray-500'>
            {client?.name
              ? t('amicales.login.subtitleWithClient', { clientName: client.name })
              : t('amicales.login.subtitleDefault')}
          </p>
        </div>

        {error ? (
          <div className='mb-4 px-3 py-2 rounded-md bg-red-50 border border-red-200 text-sm text-red-700'>
            {error}
          </div>
        ) : null}

        <label className='block mb-3'>
          <span className='block text-sm font-medium text-gray-700 mb-1'>
            {t('amicales.login.username')}
          </span>
          <div className='relative'>
            <UserOutlined className='absolute left-3 top-1/2 -translate-y-1/2 text-gray-400' />
            <input
              type='text'
              value={login}
              onChange={(e) => setLogin(e.target.value)}
              autoComplete='username'
              className='w-full pl-10 pr-3 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
              placeholder='login'
              required
            />
          </div>
        </label>

        <label className='block mb-5'>
          <span className='block text-sm font-medium text-gray-700 mb-1'>
            {t('amicales.login.password')}
          </span>
          <div className='relative'>
            <LockOutlined className='absolute left-3 top-1/2 -translate-y-1/2 text-gray-400' />
            <input
              type='password'
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete='current-password'
              className='w-full pl-10 pr-3 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
              placeholder='••••••••'
              required
            />
          </div>
        </label>

        <Button
          type='primary'
          htmlType='submit'
          loading={loading}
          block
          size='large'
          style={{
            background: 'var(--color-primary-800)',
            borderColor: 'var(--color-primary-800)',
            fontWeight: 'var(--font-weight-semibold)',
          }}
        >
          {t('amicales.login.submit')}
        </Button>
      </form>
    </div>
  );
};

export default AmicaleLoginForm;
